
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"21"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#9B9B9B","fill-rule":"evenodd","d":"M23.954 6.667H22.5V4.055c0-.629-.51-1.137-1.137-1.137H11.047L8.964 0H1.14C.51 0 0 .51 0 1.14v18.202h.002a1.059 1.059 0 001.066 1.074h18.65c.483 0 .906-.323 1.022-.755L25 7.98v-.075c0-.716-.44-1.237-1.046-1.237zM.834 1.14c0-.17.136-.306.306-.306h7.395l2.083 2.915H21.36c.17 0 .306.137.306.306v2.612H5.304c-.06 0-.118.004-.177.014-.405.07-.743.364-.842.74l-3.45 9.412V1.14zm19.112 18.27a.24.24 0 01-.228.175H1.068c-.1 0-.16-.059-.185-.093-.026-.035-.067-.106-.053-.17L5.076 7.675a.24.24 0 01.228-.175h18.65c.159 0 .2.228.21.342L19.946 19.41z"}})])
          )
        }
      }
    